import type { ReactNode } from 'react';

import { Form, ContextProvider } from '@sravni/react-silent-authentication-form';
import { UserManager } from '@sravni/utils/lib/auth';

import { AuthenticationForm } from 'entities/Authentication/ui/AuthenticationForm';

const userManager = new UserManager();

export const AUTH_MEDIA_INFO = {
  customer: 'mfo',
  productName: 'Микро-кредиты',
  authCodeChannel: 'Sms',
  source: 'MFO',
} as const;

export function Authentication({
  productId,
  content,
  onAuthorized,
}: {
  content: ReactNode;
  onAuthorized(): void;
  productId: string;
}) {
  return (
    <ContextProvider
      userManager={userManager}
      metaInfo={{
        ...AUTH_MEDIA_INFO,
        productId,
      }}
    >
      <Form onLogin={onAuthorized}>
        <AuthenticationForm content={content} />
      </Form>
    </ContextProvider>
  );
}
